import React from "react";

import SaveFormLayout from "~/components/SaveForm/SaveForm.layout";

export default function LinkLayout() {
  return <SaveFormLayout />;
}
